import { useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import content from "../content";

export default function DisclaimerBanner() {
  const [show, setShow] = useState(true);
  if (!content.disclaimer || !show) return null;

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[80] w-[calc(100%-1.5rem)] max-w-xl px-3"
      data-testid="disclaimer-banner"
    >
      <div className="flex items-start gap-3 rounded-2xl border border-gold/40 bg-ink/85 backdrop-blur-xl px-4 py-3 shadow-[0_12px_40px_-10px_rgba(0,0,0,0.85)]">
        <AlertTriangle size={18} className="text-gold mt-0.5 shrink-0" />
        <p className="font-poppins text-xs md:text-sm text-ceramic/90 leading-relaxed flex-1">
          {content.disclaimer}
        </p>
        <button
          onClick={() => setShow(false)}
          aria-label="Cerrar aviso"
          data-testid="disclaimer-close"
          className="text-white/60 hover:text-white transition-colors duration-200 shrink-0"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
